module.exports = __webpack_public_path__ + "img/station.44a9b0c1.png";